import { Component } from '@angular/core';

@Component({
    selector: 'app-castinports-data',
    templateUrl: './castinports-data.component.html',
    styleUrl: './castinports-data.component.css',
    standalone: false
})
export class CastinportsDataComponent {

}
